// extracted by mini-css-extract-plugin
export default {"formDisabled":"fGuo_TV66T2adq4ohqk9","title":"U8ChiIaGYtgJrBnVi_En","subtitle":"pzjVRfRBErwF5x8P1arF","footer":"xRNMAlgJfa6UFTH4CQRz"};